import { useState } from 'react';
import { C } from '../constants';
import { Card, SLabel } from '../components/Atoms';

export default function DischargeTab({ cur, patch, setFld, onCopy }) {
  const [copied, setCopied] = useState(false);
  const dc = cur.dischargeOrders || { medications: '', followUp: '', others: '' };
  const setDC = (field, val) => setFld('dischargeOrders', { ...dc, [field]: val });

  const handleCopy = () => {
    onCopy && onCopy();
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  const textStyle = {
    width: '100%', background: 'transparent', border: 'none',
    color: C.tx, fontSize: 13, lineHeight: 1.7, resize: 'vertical', outline: 'none',
  };

  return (
    <>
      <div style={{ background: '#1A1500', border: '1px solid #FF950044', borderRadius: 10, padding: '10px 14px', marginBottom: 12 }}>
        <div style={{ fontSize: 11, fontWeight: 800, color: cur.urgency === 'mortality' ? '#8E8E93' : '#FF9500', marginBottom: 2 }}>
          {cur.urgency === 'discharged' ? '✓ Discharged' : cur.urgency === 'mortality' ? '✝ Mortality' : '⚠ For Discharge (MGH)'}
        </div>
        <div style={{ fontSize: 11, color: '#AA7700' }}>Complete discharge orders below. Copy a patient summary for documentation and handover.</div>
      </div>

      <Card s={{ border: '1px solid #2A3A1A' }}>
        <SLabel color="#30D158">Discharge Medications</SLabel>
        <textarea value={dc.medications} onChange={e => setDC('medications', e.target.value)}
          placeholder="List discharge medications, doses, and instructions…" rows={5}
          style={{ ...textStyle }} />
      </Card>

      <Card s={{ border: '1px solid #1A2A3A' }}>
        <SLabel color="#4A9EFF">Follow-up</SLabel>
        <textarea value={dc.followUp} onChange={e => setDC('followUp', e.target.value)}
          placeholder="Follow-up appointments, referrals, instructions…" rows={4}
          style={{ ...textStyle }} />
      </Card>

      <Card>
        <SLabel color={C.dim}>Others / Special Instructions</SLabel>
        <textarea value={dc.others} onChange={e => setDC('others', e.target.value)}
          placeholder="Activity restrictions, diet, return precautions, other instructions…" rows={4}
          style={{ ...textStyle }} />
      </Card>

      <button onClick={handleCopy}
        style={{ width: '100%', padding: '14px 0', borderRadius: 12, background: copied ? '#081A0C' : '#0A1A2A', border: `1px solid ${copied ? '#30D158' : '#4A9EFF'}`, color: copied ? '#30D158' : '#7DC4FF', fontSize: 14, fontWeight: 800, cursor: 'pointer', letterSpacing: '0.04em', marginBottom: 8, transition: 'all 0.2s' }}>
        {copied ? '✓ Copied!' : '📋 Copy Patient Summary'}
      </button>
      <div style={{ fontSize: 11, color: C.dim2, textAlign: 'center' }}>
        Copies full patient record — history, labs, imaging, meds, procedures, discharge orders
      </div>
    </>
  );
}
